import { Page, PageType } from './types';

const RetailPages: Page[] = [
  {
    type: PageType.RETAILER_OVERVIEW,
    title: 'Retailer Overview',
    path: '/newron-retail/overview',
    match: /\/newron-retail\/overview?/,
  },
  {
    type: PageType.CATEGORY_LEADERBOARD,
    title: 'Category Leaderboard',
    path: '/newron-retail/category-leaderboard',
    match: /\/newron-retail\/category-leaderboard?/,
  },
  {
    type: PageType.OPPORTUNITY_REVIEW,
    title: 'Opportunity Review',
    path: '/newron-retail/opportunity-review',
    match: /\/newron-retail\/opportunity-review?/,
  },
  {
    type: PageType.PERFORMANCE_ANALYSIS,
    title: 'Performance Analysis',
    path: '/newron-retail/performance-analysis',
    match: /\/newron-retail\/performance-analysis?/,
  },
  {
    type: PageType.TRADING_ASSISTANT,
    title: 'Trading Assistant',
    path: '/newron-retail/trading-assistant',
    match: /\/newron-retail\/trading-assistant/,
  },
  {
    type: PageType.PRODUCT_ANALYZER,
    title: 'Products',
    path: '/newron-retail/products',
    match: /\/newron-retail\/products/,
  },
];

const MarketPredictPages: Page[] = [
  {
    type: PageType.GLOBAL_SUMMARY,
    title: 'Global Summary',
    path: '/global-summary',
  },
  {
    type: PageType.PRODUCTS,
    title: 'Products',
    path: '/newron/products',
  },
  {
    type: PageType.SEGMENTATION,
    title: 'Segmentation',
    path: '/newron/segmentation',
    match: /\/newron\/segmentation?/,
  },
  {
    type: PageType.PRODUCT,
    title: 'Products',
    path: '/newron/product/:id?/:tab?',
    match: /\/newron\/product?/,
  },
  {
    type: PageType.REVENUE_PREMIUM,
    title: 'Revenue Premium',
    path: '/newron/revenue-premium',
    match: /\/newron\/revenue-premium.*/,
  },
  {
    type: PageType.CONVERSION_OPPORTUNITIES,
    title: 'Conversion Opportunities',
    path: '/newron/conversion-opportunities/:page?',
  },
  {
    type: PageType.PURCHASE_FUNNEL,
    title: 'Purchase Funnel',
    path: '/newron/conversion-opportunities/purchase-funnel',
  },
  {
    type: PageType.CONSUMER_PERCEPTION,
    title: 'Consumer Perception',
    path: '/newron/conversion-opportunities/consumer-perception',
  },
  {
    type: PageType.PRICE_PLANNER,
    title: 'Price Planner',
    path: '/newron/pricing/tpr',
  },
  {
    type: PageType.PROMOTION_HISTORY,
    title: 'Promotion History',
    path: '/newron/promotions/history',
  },
  {
    type: PageType.PROMOTION_PLANNER,
    title: 'Promotion Planner',
    path: '/newron/promotions/tpr',
  },
  {
    type: PageType.PROMOTION_PLANNER,
    title: 'Promotion Planner',
    path: '/newron/promotions/tpr',
  },
  {
    type: PageType.BRAND,
    title: 'Brands',
    path: '/newron/brands',
  },
  {
    type: PageType.FORECASTING,
    title: 'Forecasting',
    path: '/newron/forecasting',
  },
  {
    type: PageType.RECOMMENDATIONS,
    title: 'Recommendations',
    path: '/newron/recommendations',
  },
  {
    type: PageType.PERFORMANCE_DRIVERS,
    title: 'Performance Drivers',
    path: '/newron/performance-drivers',
  },
  {
    type: PageType.OVERVIEW,
    title: 'Overview',
    path: ['/newron/overview', '/newron'],
  },
];

const MarketOverviewPages: Page[] = [
  {
    type: PageType.MARKET_OVERVIEW,
    title: 'Market Overview',
    path: '/mo',
  },
  {
    type: PageType.MARKET_OVERVIEW,
    title: 'Brands',
    path: '/mi/scorecard/brands',
  },
  {
    type: PageType.MARKET_OVERVIEW,
    title: 'Countries',
    path: '/mi/scorecard/countries',
  },
  {
    type: PageType.MARKET_OVERVIEW,
    title: 'Product groups',
    path: '/mi/scorecard/product-groups',
  },
  {
    type: PageType.MARKET_OVERVIEW,
    title: 'Features',
    path: '/mi/scorecard/features',
  },
  {
    type: PageType.MARKET_OVERVIEW,
    title: 'Price classes',
    path: '/mi/scorecard/prices',
  },
  {
    type: PageType.MARKET_OVERVIEW,
    title: 'Channels',
    path: '/mi/scorecard/channels',
  },
  {
    type: PageType.MARKET_OVERVIEW,
    title: 'First activity',
    path: '/mi/scorecard/first-activity',
  },
  {
    type: PageType.MARKET_OVERVIEW,
    title: 'Products',
    path: '/ml/products',
  },
];

export { MarketPredictPages, RetailPages, MarketOverviewPages };
